import { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { AppContext } from '../context/AppContext';
import { OnboardingContext } from '../context/OnboardingContext';
import OnboardingLayout from '../ui/Layout/OnboardingLayout';
import LoginCard from '../ui/LoginCard';
import OnboardingProgress from '../ui/OnboardingProgress';
import ThemeAwareLogo from '../ui/ThemeAwareLogo';

import {
  AddressContainer,
  ConnectedContainer,
  ElectricVehicleContainer,
  EquipmentDetailsContainer,
  FinalisingContainer,
  IntroductionContainer,
  ManualAddressContainer,
  NotFoundContainer,
  PvSystemContainer,
  SolarDiverterContainer,
  SolarDiverterWarningContainer,
  SubscribedContainer,
  SubscriptionContainer,
  SuccessContainer,
  TariffContainer,
} from './Onboarding';
import ConnectionContainer from './Onboarding/Connection/ConnectionContainer';
import ExportLimitContainer from './Onboarding/ExportLimitContainer';
import SmartTariffContainer from './Onboarding/SmartTariffContainer';
import SmartTariffWarningContainer from './Onboarding/SmartTariffWarningContainer';
import SolarPanelGroupsContainer from './Onboarding/SolarPanelGroupsContainer';
import SolarPanelsContainer from './Onboarding/SolarPanelsContainer';

const OnboardingContainer = () => {
  const { progressPercentage } = useContext(OnboardingContext);
  const { subscriptionsDisabled } = useContext(AppContext);
  const theme = useTheme();
  return (
    <OnboardingLayout backgroundTint="blue" showSignOut={true}>
      <LoginCard>
        {theme.layout.showOrHideElements.onBoarding.showCompanyLogoInCard && (
          <Row>
            <Col className="px-lg-3 px-md-2 px-1 d-flex justify-content-center mb-3">
              <ThemeAwareLogo className="d-sm-block onboard-logo" alt="Company Logo" />
            </Col>
          </Row>
        )}
        {progressPercentage > 0 && <OnboardingProgress percentage={progressPercentage} />}
        <Routes>
          <Route index element={<IntroductionContainer />} />
          <Route path="introduction" element={<IntroductionContainer />} />
          <Route path="address" element={<AddressContainer />} />
          <Route path="manual-address" element={<ManualAddressContainer />} />
          <Route path="smart-tariff" element={<SmartTariffContainer />} />
          <Route path="smart-tariff-warning" element={<SmartTariffWarningContainer />} />
          <Route path="tariff" element={<TariffContainer />} />
          <Route path="pv-system" element={<PvSystemContainer />} />
          <Route path="solar-panels" element={<SolarPanelsContainer />} />
          <Route path="solar-panels/details" element={<SolarPanelGroupsContainer />} />
          <Route path="solar-diverter" element={<SolarDiverterContainer />} />
          <Route path="solar-diverter-warning" element={<SolarDiverterWarningContainer />} />
          <Route path="electric-vehicle" element={<ElectricVehicleContainer />} />
          <Route path="equipment-details" element={<EquipmentDetailsContainer />} />
          <Route path="export-limit" element={<ExportLimitContainer />} />
          <Route path="connection/:manufacturer" element={<ConnectionContainer />} />
          <Route path="connected" element={<ConnectedContainer />} />
          {!subscriptionsDisabled && <Route path="subscription" element={<SubscriptionContainer />} />}
          {!subscriptionsDisabled && <Route path="subscribed" element={<SubscribedContainer />} />}
          <Route path="finalising" element={<FinalisingContainer />} />
          <Route path="success" element={<SuccessContainer />} />
          <Route path="not-found" element={<NotFoundContainer />} />
          <Route path="*" element={<Navigate to="not-found" />} />

          {/*<Route
              path="/onboarding/error"
              element={<ErrorContainer />}
            /> */}
        </Routes>
      </LoginCard>
    </OnboardingLayout>
  );
};

export default OnboardingContainer;
